export enum TripTypeEnum {
  BUSINESS,
  PRIVATE
}
